import { usePrograms } from "../hooks/usePrograms";

export default function CoursesPage() {
  const { programs, loading, error } = usePrograms();

  return (
    <div className="page">
      <header className="page__hero">
        <h1>Our Programs</h1>
        <p>
          Explore each program in depth-what you will learn, how long it takes, and the career paths it unlocks.
        </p>
      </header>

      <section className="section">
        <div className="section__inner">
          <div className="section__header">
            <span className="section__tag">Programs</span>
            <h2 className="section__title">Choose Your Specialisation</h2>
            <p className="section__subtitle">
              All programs combine theory, hands-on projects, and career preparation with industry mentors.
            </p>
          </div>

          {loading ? (
            <p style={{ textAlign: "center", color: "var(--text-muted)" }}>Loading programs...</p>
          ) : error ? (
            <p style={{ textAlign: "center", color: "#c62828" }}>{error}</p>
          ) : (
            <div className="program-detail-grid">
              {programs.map((program) => (
                <div key={program.name} className="program-detail-card">
                  <div className="program-detail-card__image-wrap">
                    <img src={program.image} alt={program.name} className="program-detail-card__image" loading="lazy" />
                    <span className="program-detail-card__pill">{program.duration}</span>
                  </div>

                  <header className="program-detail-card__head">
                    <h3>{program.name}</h3>
                    <div className="program-detail-card__meta">
                      <span>{program.duration}</span>
                      <span>{program.intake}</span>
                    </div>
                  </header>

                  <p className="program-detail-card__desc">{program.description}</p>

                  <div className="program-detail-card__section">
                    <h4>Entry Requirements</h4>
                    <ul>
                      {program.requirements.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                  </div>

                  <div className="program-detail-card__section">
                    <h4>Skills You Gain</h4>
                    <ul>
                      {program.skills.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                  </div>

                  <div className="program-detail-card__section">
                    <h4>Career Opportunities</h4>
                    <ul>
                      {program.careers.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
